import request from '../helpers/request';

const getDashboardRequest = async (requestId, errMsg) => {
  return await request.get(
    `/Request/dashboard`,
    { requestId },
    errMsg || `При загрузке заявки произошла ошибка`,
    []
  );
};

export default getDashboardRequest;
